export class Tax {
  taxId: number;
  name: string;
  value: number;
}
